import { render, staticRenderFns } from "./ProductWithCollection.vue?vue&type=template&id=32b80a22&scoped=true&"
import script from "./ProductWithCollection.vue?vue&type=script&lang=js&"
export * from "./ProductWithCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b80a22",
  null
  
)

export default component.exports